import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { EN_DEFAULT, TranslationKey } from './translations';

export const DEFAULT_LANGUAGE = 'en-US';

/**
 * Shared by nymbl2 and nymbl3 (both resolve `@translations/*` to this folder).
 * Translations ship with the bundle (src/locale/en-US.json) rather than being fetched
 * at runtime, so the loader just hands back the compiled-in map. Swap for an HTTP
 * loader when additional locales are added.
 */
@Injectable()
export class AppTranslateLoader implements TranslateLoader {
  getTranslation(_lang: string): Observable<Record<TranslationKey, string>> {
    return of(EN_DEFAULT);
  }
}
